module.exports = __webpack_public_path__ + "img/automation.0f1ae076.jpg";